export function PlayAudio(myAudio) {
  myAudio.play();
  console.log('MYAUDIO')
}
export function PauseAudio(myAudio) {
  myAudio.pause();
  console.log('MYAUDIO')
}